import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [], 
};

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
   
    setNotifications: (state, action) => {
      state.items = action.payload;
    },
    
    markSingleAsRead: (state, action) => {
      const id = action.payload;
      const item = state.items.find((n) => (n.id === id || n._id === id));
      if (item) {
        item.isRead = true;
      }
    },
    
    markAllAsReadComplete: (state) => {
      state.items = state.items.map((item) => ({ ...item, isRead: true }));
    },
  },
});

export const { setNotifications, markSingleAsRead, markAllAsReadComplete } = notificationSlice.actions;
export default notificationSlice.reducer;